// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07e9a568","239":"ce7015ac","455":"6a4dbab3"}[chunkId] + ".chunk.js";
};